/* Built In Imports */
import { Box } from '@chakra-ui/react';

/* External Imports */

/* Internal Imports */
/* Components */
import config from '@config';
import CardInfo4 from '@eternal/Components/Card/CardInfo4';
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import MidContainer from '@eternal/Components/Layout/MidContainer';

/* Services */

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const SinglesTitle = ({ sectionContent }) => {
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);
  return (
    <Box
      pos="relative"
      background="#040404"
      _before={{
        content: "''",
        width: { base: '50%', md: '20%', lg: '20%' },
        height: '40%',
        pos: 'absolute',
        backgroundImage: `${config.imgPath}/d/46272/1725007996-layer-2-2.png`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top',
        right: '0',
        top: '0',
        zIndex: 0,
      }}
      w="100%"
    >
      <MidContainer>
        <SectionTitle titleObj={findElement('section_title')} />
        <CardInfo4 sectionContent={findElement('card_info4_column_group')} />
      </MidContainer>
    </Box>
  );
};

export default SinglesTitle;
